import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { ShiftConfigWithBreaksForm } from '../forms'

export interface Props {
  form: ShiftConfigWithBreaksForm
  onAddShift: () => void
  onAddRestDay: () => void
  onAddEmptyCell: () => void
}

const DayPopover = ({ form, onAddShift, onAddRestDay, onAddEmptyCell }: Props) => {
  const { shiftConfig } = form

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName="add" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end" width="s200">
        {!shiftConfig.isRestDay && (
          <PopoverMenu.TouchableOption
            title={i18n.t('shift_management.templates.actions.add_rest_day')}
            onClick={onAddRestDay}
          />
        )}
        {!shiftConfig.isEmptyCell && (
          <PopoverMenu.TouchableOption
            title={i18n.t('shift_management.templates.actions.add_empty_cell')}
            onClick={onAddEmptyCell}
          />
        )}
        <PopoverMenu.TouchableOption
          title={i18n.t('settings.work_schedule.period_section.add_shift')}
          onClick={onAddShift}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default observer(DayPopover)
